import { AppThunk } from '../../types';
import {
  setDiscountsAction,
  setDiscountsErrorAction,
  setDiscountsFetchStatusAction,
  setUpdateDiscountsErrorAction,
  setUpdateDiscountsFetchStatusAction,
} from './reducer';
import {
  createDefaultFetch,
  createFetchedSuccess,
  createFetchedWithError,
  createFetchInProgress,
} from 'types/rest/IFetchStatus';
import { getDiscountsAsync, updateDiscountsAsync } from 'API/order/fees/discountsAPI';

export const getDiscounts =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    dispatch(setDiscountsFetchStatusAction({ orderId, value: createDefaultFetch() }));
    dispatch(setDiscountsErrorAction({ orderId, value: null }));
    try {
      dispatch(setDiscountsFetchStatusAction({ orderId, value: createFetchInProgress() }));
      const discounts = await getDiscountsAsync(orderId);
      dispatch(setDiscountsAction({ orderId, value: discounts }));
      dispatch(setDiscountsFetchStatusAction({ orderId, value: createFetchedSuccess() }));
    } catch (e: any) {
      dispatch(setDiscountsErrorAction({ orderId, value: e }));
      dispatch(setDiscountsFetchStatusAction({ orderId, value: createFetchedWithError() }));
    }
  };

export const updateDiscounts =
  (orderId: string, discountId: string): AppThunk =>
  async (dispatch) => {
    dispatch(setUpdateDiscountsFetchStatusAction({ orderId, value: createDefaultFetch() }));
    dispatch(setUpdateDiscountsErrorAction({ orderId, value: null }));
    try {
      dispatch(setUpdateDiscountsFetchStatusAction({ orderId, value: createFetchInProgress() }));
      const discounts = await updateDiscountsAsync(orderId, discountId);
      dispatch(setDiscountsAction({ orderId, value: [discounts] }));
      dispatch(setUpdateDiscountsFetchStatusAction({ orderId, value: createFetchedSuccess() }));
    } catch (e: any) {
      dispatch(setUpdateDiscountsErrorAction({ orderId, value: e }));
      dispatch(setUpdateDiscountsFetchStatusAction({ orderId, value: createFetchedWithError() }));
      throw e;
    }
  };
